__turbopack_context__.v({
  "hasReacted": "Reactions-module__4O-l-G__hasReacted",
  "reactionBadge": "Reactions-module__4O-l-G__reactionBadge",
});
